import React, { useState, useEffect } from 'react';

function MerchantLookup({ onLookup, loading, initialData }) {
  const [formData, setFormData] = useState({
    merchantName: '',
    location: '',
    estimatedAmount: '',
  });

  useEffect(() => {
    if (initialData) {
      setFormData((prev) => ({
        ...prev,
        merchantName: initialData.name || initialData.merchantName || '',
        location: initialData.location || '',
      }));
    }
  }, [initialData]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.merchantName) {
      alert('Please enter a merchant name');
      return;
    }
    onLookup(formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-3">
      <div>
        <label htmlFor="merchantName" className="block text-sm font-medium text-on-surface mb-1.5">
          Store or Merchant *
        </label>
        <input
          type="text"
          id="merchantName"
          name="merchantName"
          placeholder="e.g., Lululemon, Whole Foods, Apple"
          value={formData.merchantName}
          onChange={handleChange}
          required
          disabled={loading}
          className="w-full px-4 py-3 bg-surface-container-low border border-outline-variant/40 rounded-2xl text-sm text-on-surface placeholder:text-on-surface-variant/50 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all disabled:opacity-50"
        />
      </div>

      <div className="grid grid-cols-2 gap-3">
        <div>
          <label htmlFor="location" className="block text-sm font-medium text-on-surface mb-1.5">
            Location
          </label>
          <input
            type="text"
            id="location"
            name="location"
            placeholder="e.g., NYC or 10001"
            value={formData.location}
            onChange={handleChange}
            disabled={loading}
            className="w-full px-4 py-3 bg-surface-container-low border border-outline-variant/40 rounded-2xl text-sm text-on-surface placeholder:text-on-surface-variant/50 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all disabled:opacity-50"
          />
        </div>
        <div>
          <label htmlFor="estimatedAmount" className="block text-sm font-medium text-on-surface mb-1.5">
            Est. Amount
          </label>
          <input
            type="number"
            id="estimatedAmount"
            name="estimatedAmount"
            placeholder="$100"
            value={formData.estimatedAmount}
            onChange={handleChange}
            disabled={loading}
            className="w-full px-4 py-3 bg-surface-container-low border border-outline-variant/40 rounded-2xl text-sm text-on-surface placeholder:text-on-surface-variant/50 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary transition-all disabled:opacity-50"
          />
        </div>
      </div>

      <button
        type="submit"
        className="w-full py-3.5 bg-gradient-to-r from-primary via-primary to-primary-dark text-on-primary rounded-2xl text-sm font-semibold hover:shadow-md active:scale-[0.97] transition-all duration-200 disabled:opacity-50"
        disabled={loading}
      >
        {loading ? 'Searching...' : 'Find Best Card'}
      </button>
    </form>
  );
}

export default MerchantLookup;
